import { supabase } from "@/integrations/supabase/client";

export async function shouldReceiveConversationPush(
  workspaceId: string,
  userId: string,
  leadId: string | null,
  channel: string | null,
  integrationId: string | null,
): Promise<boolean> {
  const { data, error } = await supabase.rpc("member_should_receive_conversation_push", {
    _user_id: userId,
    _workspace_id: workspaceId,
    _lead_id: leadId,
    _channel: channel,
    _integration_id: integrationId,
  });

  if (error) {
    console.warn("push eligibility rpc failed:", error.message);
    return false;
  }

  return data === true;
}
